import { useState, useRef, useEffect } from "react";

const useRefState = initialValue => {
  const [state, setState] = useState(initialValue);
  const stateRef = useRef(state);
  useEffect(() => {
    stateRef.current = state;
  }, [state]);
  return [state, stateRef, setState];
};

export default useRefState;


/** 
 *Example:

  const [current, currentRef, setCurrent] = useRefState([]);

  currentRef.current;

*/